import React from 'react'

export default function DownArrow({width, height, color}) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width ? width : '24'} height={height ? height :'24'} fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke={color ? color : "currentColor"} className="w-6 h-6">
        <path strokeLinecap="round" height={height ? height : ""} width={width ? width : ""} strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
    </svg>
  )
}
